import { Component, computed, inject, input } from '@angular/core';
import { Category, CategoryCollection } from "@gea-waldviertler-website/gea-models";
import { BreadcrumbService, PageService } from "@gea-waldviertler-website/shop-lib";

@Component({
  selector: 'gea-shop-navigation-category-accordion',
  templateUrl: 'accordion.component.html',
  styleUrls: ['accordion.component.scss'],
  standalone: false,
})
export class NavigationCategoryAccordionComponent {
  categories = input.required<CategoryCollection>()
  level = input<number>(0)
  bcService = inject(BreadcrumbService)
  public pageService = inject(PageService)

  allCategories = computed(() => {
    const bs = this.pageService.getBootstrapSignal()()
    return bs.categories
  })

  /**
   * This holds the category path of the current page to allow the accordion to open the correct category.
   */
  catPath = computed<number[]>(() => {
    const bcPath = this.bcService.path()
    let cp: number[] = []
    if (bcPath) {
      for (const bc of bcPath) {
        if (bc.type == "category") {
          cp.push(bc.payload.category.id)
        }
      }
      // on empty category path, check if product and expand the main category of the product
      if (! cp.length) {
        for (const bc of bcPath) {
          if (bc.type == "product") {
            const mc = bc.payload.product.mainCategory
            if (mc) cp.push(mc.id)
          }
        }
      }
    }
    return cp
  })

  ariaLabel(category: Category) {
    let categories = this.allCategories().getCategoryPath(category)
    return categories.map(c => c.name).join(" - ")
  }
}
